import { z } from 'zod'

export const ConfigApp = z
  .object({
    appType: z.string(),
    name: z.string(),
    description: z.string(),
    logo: z.string(),
    icon: z.string(),
    url: z.string(),
    details: z.object({
      supportedDataTypes: z.array(z.string()),
      supportedActions: z.array(z.string()),
      internalHelpUrl: z.string().nullable(),
      externalHelpUrl: z.string().nullable(),
    }),
  })
  .strict()

export type ConfigApp = z.infer<typeof ConfigApp>

export const apps: ConfigApp[] = [
  {
    appType: 'gastromatic',
    name: 'Gastromatic',
    description:
      'Gastromatic ist eine Software für die digitale Personalplanung in der Gastronomie.',
    url: 'https://www.gastromatic.com/',
    logo: 'gastromatic.svg',
    icon: 'gastromatic.svg',
    details: {
      supportedDataTypes: ['employees'],
      supportedActions: ['read'],
      internalHelpUrl: null,
      externalHelpUrl: null,
    },
  },
  {
    appType: 'personio',
    name: 'Personio',
    description:
      'Personio ist eine HR-Software, mit der Sie Ihre HR-Prozesse und Dokumente an einem Ort verwalten können.',
    url: 'https://www.personio.com/',
    logo: 'personio.svg',
    icon: 'personio_icon.svg',
    details: {
      supportedDataTypes: [
        'employees',
        'absences',
        'one-time-payments',
        'documents',
      ],
      supportedActions: ['read', 'write'],
      internalHelpUrl:
        'https://hilfe.cleverlohn.de/de/collections/5559553-fur-kanzleien-lohnbuchhalter-innen',
      externalHelpUrl: 'https://support.personio.de',
    },
  },
  {
    appType: 'crewmeister',
    name: 'Crewmeister',
    description:
      'Crewmeister ist eine Zeiterfassungssoftware für die einfache Verwaltung von Arbeitszeiten.',
    url: 'https://www.crewmeister.com/',
    logo: 'crewmeister.svg',
    icon: 'crewmeister.svg',
    details: {
      supportedDataTypes: [],
      supportedActions: ['read'],
      internalHelpUrl: null,
      externalHelpUrl: null,
    },
  },
]

export const appsByUids = apps.reduce(
  (acc, app) => {
    acc[app.appType] = app
    return acc
  },
  {} as { [key: string]: ConfigApp }
)
